import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../Navbar";
import Footer from "../Footer";
import InternationalAtHome from "../InternationalRelation/InternationalAtHome/InternationalAtHome";
import StudentRecruitment from "./InternationalStudentRecruitmrnt";
import StudyInIndia from "./WhyStudyInIndia";
import ImmersionProgramme from "./GlobalImmersionProgramme";
import MobilityProgramme from "./StudentMobilityProgram";
import StudentWork from "./StudentExchangeProgramWork";
import CollaborativePage from "../InternationalRelation/Collaborative/CollaborativePage";
import Regulatory from "./InternationalRelationJSON/Regulatory";
import InternshipOpportunities from "./InternshipOpportunities";
// import Testimonial from "../Testimonial";                                              // Required Later
// import { testimonialCard } from "./InternationalRelationJSON/testimonialJson";
import { Box } from "@mui/material";

const InternationalRelationMainPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      {/* ------Header------ */}
      <Helmet>
        <title>International Engagement | Taksheela Institute</title>
      </Helmet>
      <Navbar />

      {/* ---------Your Component Code Goes Here--------- */}
      <InternationalAtHome />
      <Regulatory />
      {/* <Testimonial  testimonialCard={testimonialCard}/>                                // Required Later           */}
      <StudentRecruitment />
      <StudyInIndia />
      <ImmersionProgramme />
      <MobilityProgramme />
      <CollaborativePage />
      <InternshipOpportunities />
      <StudentWork />

      {/* -----Footer------ */}
      <Box sx={{ py: 5 }}>
        <Footer />
      </Box>
    </div>
  );
};

export default InternationalRelationMainPage;

